<div class="live-results">
  <div class="spinner mx-auto my-8" *ngIf="isLoading"></div>

  <div *ngIf="totalItems > 0 && !isLoading" class="vtmn-title-4 mt-4">
    {{ totalItems | totalResults }}
  </div>

  <app-attendee-pagination
    *ngIf="!isLoading"
    class="block mt-4"
    [items]="events"
    [itemsType]="paginationType.TIMESLOTS"
    (filterReset)="resetFilters()"
  ></app-attendee-pagination>

  <app-list-pagination
    *ngIf="!isLoading && pagination"
    [pagination]="pagination"
    targetUrl="/attendee.result-page/attendee.live-activities"
  />
</div>
